import React from "react";
import { Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./SocialMediaNotConnectedModal.scss";
import { clientRoutes } from "../../../../utils/routes";

/**
 * SocialMediaNotConnectedModal
 *
 *
 * @param {Object} props
 * @param {boolean} props.open - Modal open
 * @param {Function} props.onClose - Modal close
 * @param {string} props.platformName - Platform name (Facebook, Instagram, etc.)
 */
const SocialMediaNotConnectedModal = ({
  open,
  onClose,
  platformName = "Facebook",
}) => {
  const navigate = useNavigate();

  const handleConnect = () => {
    onClose?.();
    navigate(clientRoutes.socialMediaAccounts);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="social-media-not-connected-modal"
      disableEscapeKeyDown
      aria-labelledby="social-media-not-connected-title"
    >
      <div className="social-media-not-connected-modal__card">
        <div className="social-media-not-connected-modal__icon-wrapper">
          <img
            src="/images/brand_verification_pending.svg"
            alt="Warning"
            className="social-media-not-connected-modal__icon"
          />
        </div>

        <h2
          id="social-media-not-connected-title"
          className="social-media-not-connected-modal__title"
        >
          Your {platformName} Account is Not Connected
        </h2>

        <p className="social-media-not-connected-modal__text">
          Please connect your {platformName} account to automate and publish
          your social media marketing content
        </p>

        <div className="social-media-not-connected-modal__actions">
          <button
            type="button"
            className="social-media-not-connected-modal__btn social-media-not-connected-modal__btn--outline"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="button"
            className="social-media-not-connected-modal__btn social-media-not-connected-modal__btn--primary"
            onClick={handleConnect}
          >
            Connect social media accounts
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SocialMediaNotConnectedModal;